import { render, staticRenderFns } from "./testQuestion.vue?vue&type=template&id=44d000aa&scoped=true&"
import script from "./testQuestion.vue?vue&type=script&lang=ts&"
export * from "./testQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./testQuestion.vue?vue&type=style&index=0&id=44d000aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d000aa",
  null
  
)

export default component.exports